var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/cartdrawer.js
var cartDrawer = class {
  constructor() {
    __publicField(this, "handleOutsideClick", (event) => {
      if (event.target === this.curtain)
        this.close();
    });
    this.cartDrawerElement = document.querySelector("cart-drawer");
    this.curtain = document.querySelector("#curtain");
  }
  open() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    this.cartDrawerElement.setAttribute("aria-hidden", "false");
    this.curtain.setAttribute("aria-hidden", "false");
    this.curtain.addEventListener("click", this.handleOutsideClick);
    setTimeout(() => {
      desktopRecommendations.setAttribute("aria-hidden", "false");
      desktopRecommendations.style.visibility = "visible";
    }, 250);
  }
  close() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    desktopRecommendations.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.cartDrawerElement.setAttribute("aria-hidden", "true");
      this.curtain.setAttribute("aria-hidden", "true");
      this.curtain.removeEventListener("click", this.handleOutsideClick);
      desktopRecommendations.style.visibility = "hidden";
    }, 250);
  }
};
var cartdrawer_default = new cartDrawer();

// src/utils/get-sections.js
var getCartSectionsToRender = (includeRecommendations = true) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const sectionConfig = [
    {
      id: "cart-items",
      section: (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.id,
      selector: "#cart-items"
    },
    {
      id: "mobile-recommendations",
      section: (_b = document.querySelector("cart-drawer")) == null ? void 0 : _b.id,
      selector: "#mobile-recommendations"
    },
    {
      id: "cartdrawer-progress",
      section: (_c = document.querySelector("cart-drawer")) == null ? void 0 : _c.id,
      selector: "#cartdrawer-progress"
    },
    {
      id: "cartdrawer-head",
      section: (_d = document.querySelector("cart-drawer")) == null ? void 0 : _d.id,
      selector: "#cartdrawer-head"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-footer",
      section: (_e = document.querySelector("cart-drawer")) == null ? void 0 : _e.id,
      selector: "#cart-footer"
    },
    {
      id: "desktop-recommendations",
      section: ((_f = document.querySelector(".main-cart__inner")) == null ? void 0 : _f.id) ? (_g = document.querySelector(".main-cart__inner")) == null ? void 0 : _g.id : (_h = document.querySelector("cart-drawer")) == null ? void 0 : _h.id,
      selector: "#desktop-recommendations"
    },
    {
      id: "cart-summary-desktop",
      section: ((_i = document.querySelector(".main-cart__inner")) == null ? void 0 : _i.id) ? (_j = document.querySelector(".main-cart__inner")) == null ? void 0 : _j.id : (_k = document.querySelector("cart-drawer")) == null ? void 0 : _k.id,
      selector: "#cart-summary-desktop"
    },
    {
      id: "cart-items-desktop",
      section: ((_l = document.querySelector(".main-cart__inner")) == null ? void 0 : _l.id) ? (_m = document.querySelector(".main-cart__inner")) == null ? void 0 : _m.id : (_n = document.querySelector("cart-drawer")) == null ? void 0 : _n.id,
      selector: "#cart-items-desktop"
    }
  ];
  const filtered = includeRecommendations ? sectionConfig : sectionConfig.filter((s) => !["mobile-recommendations", "desktop-recommendations"].includes(s.id));
  return {
    sections: filtered.map((item) => item.section).filter(Boolean),
    selectors: filtered.map((item) => item.selector)
  };
};

// src/utils/section-rendering.js
var renderSections = (dom, sectionsArray) => {
  sectionsArray.forEach((section) => {
    const source = dom.querySelector(section);
    const destination = document.querySelector(section);
    if (source && destination)
      destination.outerHTML = source.outerHTML;
  });
};
var section_rendering_default = renderSections;

// src/utils/error-handler.js
var errorHandler = class {
  /**
   * lock the body to prevent scrolling.
   */
  showError(message) {
    const errorMessage = document.querySelector("#error-message");
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "false");
    errorMessage.innerHTML = message;
    setTimeout(() => {
      this.hideError();
    }, 5e3);
  }
  /**
   * unlock the scrolling of the body.
   */
  hideError() {
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "true");
  }
};
var error_handler_default = new errorHandler();

// src/extenders/product-button.js
var productButton = class extends HTMLElement {
  constructor() {
    var _a, _b;
    super();
    const quickAddToggle = this.querySelector(".js-quick-add-toggle");
    const curtain = document.querySelector("#curtain");
    const quickAddModalClass = `js-quick-add-modal-${this.id}`;
    const adjacentQuickAddModal = ((_b = (_a = this.nextElementSibling) == null ? void 0 : _a.classList) == null ? void 0 : _b.contains(quickAddModalClass)) ? this.nextElementSibling : null;
    const closeQuickAddModal = (quickAddModal) => {
      quickAddToggle == null ? void 0 : quickAddToggle.focus();
      quickAddModal == null ? void 0 : quickAddModal.setAttribute("aria-hidden", "true");
      curtain == null ? void 0 : curtain.setAttribute("aria-hidden", "true");
    };
    const quickAddToCart = (id, quickAddModal) => {
      const { sections, selectors } = getCartSectionsToRender();
      const data = {
        items: [
          {
            id,
            quantity: 1
          }
        ],
        sections
      };
      if (quickAddModal === null) {
        quickAddToggle.setAttribute("aria-busy", true);
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      }).then((r) => r.json().then((d) => r.ok ? d : Promise.reject(new Error(d.message)))).then((responseData) => {
        console.log(responseData);
        const parser = new DOMParser();
        Object.entries(responseData.sections).forEach(([, sectionData]) => {
          const dom = parser.parseFromString(sectionData, "text/html");
          section_rendering_default(dom, selectors);
        });
        closeQuickAddModal(quickAddModal);
        quickAddToggle.setAttribute("aria-busy", false);
        cartdrawer_default.open();
      }).catch((error) => {
        error_handler_default.showError(error.message);
        this.setAttribute("aria-busy", false);
      });
    };
    const handleQuickAdd = () => {
      const quickAddModal = adjacentQuickAddModal || document.querySelector(`.${quickAddModalClass}`);
      if (quickAddModal) {
        if (quickAddModal.parentElement !== document.body) {
          document.body.appendChild(quickAddModal);
        }
        const a2cButton = quickAddModal.querySelector(".js-add-to-cart");
        const closeButtons = quickAddModal.querySelectorAll(".js-close");
        quickAddModal.setAttribute("aria-hidden", "false");
        curtain == null ? void 0 : curtain.setAttribute("aria-hidden", "false");
        closeButtons == null ? void 0 : closeButtons.forEach((closeButton) => {
          closeButton.onclick = () => {
            closeQuickAddModal(quickAddModal);
          };
        });
        a2cButton == null ? void 0 : a2cButton.addEventListener("click", () => {
          quickAddToCart(this.id, quickAddModal);
        });
      } else {
        quickAddToCart(this.id, null);
      }
    };
    if (quickAddToggle) {
      quickAddToggle.addEventListener("click", () => handleQuickAdd());
    }
  }
};
if (customElements.get("product-button") === void 0) {
  customElements.define("product-button", productButton);
}
